import {TradeTagWrite} from '@cp/model';
import {updateDoc} from 'firebase/firestore';
import {getCurrentUserIdValidated} from '../../config/firebase';
import {getTradeTagDocRef} from './getTradeTagDocRef';

export async function updateTradeTag(id: string, input: Partial<TradeTagWrite>): Promise<void> {
  const uid = await getCurrentUserIdValidated();
  const docRef = getTradeTagDocRef(uid, id);
  await updateDoc(docRef, input);
}
